import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { globalIssueNavigatorEntryPoint } from '@atlassian/jira-spa-apps-global-issue-navigator/entrypoint.tsx';
import { nativeIssueTableEntryPoint } from '@atlassian/jira-native-issue-table/src/ui/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { jqlBuilderWithAiEntryPoint } from '@atlassian/jira-jql-builder-with-ai/src/ui/entrypoint.tsx';
import { issueAppEntryPoint } from '@atlassian/jira-issue-view/src/views/issue-details/issueAppEntryPoint.tsx';

export const globalIssueNavigatorGinRedirectEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-global-issue-navigator-gin-redirect-entrypoint" */ './index.tsx'
			),
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (entryPointParams: EntryPointRouteParams) => {
		let issueKey = entryPointParams?.context?.match?.params?.issueKey;
		// current prod bug workaround: on issue view, issueKey is passed in as selectedIssue query param instead of route param
		if (fg('nin_issue_app_conditional_entrypoint')) {
			issueKey = entryPointParams?.context?.query?.selectedIssue;
		}
		return {
			entryPoints: {
				globalIssueNavigatorEntryPoint: {
					entryPoint: globalIssueNavigatorEntryPoint,
					entryPointParams,
				},
				...(!issueKey
					? {
							nativeIssueTableEntryPoint: {
								entryPoint: nativeIssueTableEntryPoint,
								entryPointParams,
							},
							...(fg('jql_builder_basic_ssr_stability_fixes')
								? {
										jqlBuilderWithAiEntryPoint: {
											entryPoint: jqlBuilderWithAiEntryPoint,
											entryPointParams,
										},
									}
								: {}),
						}
					: {}),
				...(issueKey && fg('nin_issue_app_conditional_entrypoint')
					? {
							issueAppEntryPoint: {
								entryPoint: issueAppEntryPoint,
								entryPointParams,
							},
						}
					: {}),
			},
		};
	},
});
